<template>
  <div>
    <title-component
      :size="2"
      :lineSeparator="'under'">
      <translate> {{ title }} </translate>
    </title-component>
    <slot></slot>
    <hr v-if="showBtn">
    <div v-if="showBtn" class="columns is-multiline approve-all-section is-variable is-2">
      <div class="column is-6">
        <p class="has-text-weight-semibold is-uppercase" v-translate>Approve all information</p>
      </div>
      <div class="column is-6">
        <submit-btn-component class="is-primary is-outlined" @submit="approveAll(reviewResults, $event)">
          <translate>Approve all</translate>
          <span class="icon is-large">
            <i class="mdi mdi-check-all"></i>
          </span>
        </submit-btn-component>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'
  import { ReviewResultState } from '@/classes/case/ReviewResult'
  import { errorHandler } from '@/mixins/mixins'

  export default {
    name: 'review-service-component',
    mixins: [errorHandler],
    components: {
      TitleComponent,
      SubmitBtnComponent
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      caseId: {
        required: false
      },
      reviewResults: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      showBtn () {
        return this.reviewResults.length && this.caseId
      }
    },
    methods: {
      ...mapActions([
        'updateAllReviewResultsState'
      ]),
      approveAll (reviewResults, btn) {
        let resultsStateOK = []
        reviewResults.forEach(result => {
          resultsStateOK.push({
            state: ReviewResultState.getStateByValue(ReviewResultState.OK),
            id: result.id
          })
        })
        let patchData = {
          current: reviewResults,
          reviewResults: resultsStateOK,
          caseId: this.caseId
        }
        this.updateAllReviewResultsState(patchData).then((response) => {
          this.$emit('approved')
          btn.enable()
        }).catch((err) => {
          btn.enable()
          this.handleError(err)
        })
      }
    }
  }
</script>
